export default __webpack_public_path__ + "static/media/sidebar-home.baeab6bc.svg";